import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, Shield } from "lucide-react";

export default function SubscriptionSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const attempts = useRef(0);
  const { checkAuth, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!session_id) { setStatus("done"); return; }
    const poll = async () => {
      try {
        await checkAuth();
        const { data } = await api.get("/subscriptions/status");
        if (data.active) {
          setStatus("done");
          return;
        }
        attempts.current += 1;
        if (attempts.current > 30) { setStatus("done"); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setStatus("done");
      }
    };
    poll();
  }, [session_id, checkAuth]);

  const active = user?.subscription_status === "active" || user?.subscription_status === "trialing";

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="subscription-success-page">
      <div className="max-w-md w-full bg-card border border-border rounded-md p-8 text-center">
        {status === "polling" ? (
          <>
            <Loader2 className="w-10 h-10 text-primary animate-spin mx-auto" />
            <h1 className="font-display font-bold text-2xl mt-4">Activating your Pass…</h1>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
              {active ? <CheckCircle2 className="w-8 h-8 text-primary" /> : <Shield className="w-8 h-8 text-secondary" />}
            </div>
            <h1 className="font-display font-extrabold text-3xl mt-4">
              {active ? "Firearms Pass active" : "Almost there"}
            </h1>
            <p className="text-muted-foreground mt-3 text-sm">
              {active
                ? "You now have access to buy, sell and trade firearms, ammo, and NFA items on Florida Sportsman."
                : "Your subscription is processing. It should be active in a moment."}
            </p>
            <div className="flex flex-col gap-2 mt-8">
              <Button onClick={() => navigate("/marketplace")} className="bg-primary hover:bg-primary/90" data-testid="btn-go-marketplace">
                Browse the marketplace
              </Button>
              <Button variant="outline" onClick={() => navigate("/firearms/verify")} data-testid="btn-verify-age">
                {user?.firearms_disclaimer_accepted_at ? "Update age verification" : "Complete age verification"}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
